import React, { useEffect, useState } from "react";
import FullScreenLoader from "../../../components/fullScreenLoader/fullScreenLoader";
import GetTest from "../../../container/getTest/getTest";
import ChoiceReaction from "../../../container/tChoiceReaction/choiceReaction";
import CPT from "../../../container/tCPT/CPT";
import DualNBack1 from "../../../container/tDualNBack1/dualNBack1";
import TestSummary from "../../../container/testSummary/testSummary";
import FaceNameMix from "../../../container/tFaceNameMix/faceNameMix";
import ListenSpeak from "../../../container/tListenSpeak/listenSpeak";
import ListenSpeakPara from "../../../container/tListenSpeakPara/listenSpeakPara";
import MultiFill from "../../../container/tMultiFill/multiFill";
import MultiTap from "../../../container/tMultiTap/multiTap";
import ShuffleSentence from "../../../container/tShuffleSentence/shuffleSentence";
import SimpleReaction from "../../../container/tSimpleReaction/simpleReaction";
import SimpleSoundReaction from "../../../container/tSimpleSoundReaction/simpleSoundReaction";
import SpeedImgRecall from "../../../container/tSpeedImgRecall/speedImgRecall.jsx";
import TextMatch from "../../../container/tTextMatch/tTextMatch";
import VisualKeypad from "../../../container/tVisualKeypad/visualKeypad";
import { getCPTData } from "../../../helper/constant/getCPTData";
import { getSpeedImgRecall } from "../../../helper/constant/getSpeedImgRecall";
import { getTextMatching } from "../../../helper/constant/getTextMatch";
import { getVisualFNMix } from "../../../helper/constant/getVisualFNMix";
import { objectValidation } from "../../../helper/validation";
import { AnswerContext } from "../../../store/answerStore";
import { HelperContext } from "../../../store/helperStore";
import { LaunchTestContext } from "../../../store/launchTestStore";
import DigitMemorySpan from "../../../container/tDigitMemorySpan/digitMemorySpan.jsx";
import ReverseNumberSequence from "../../../container/tReverseNumberSequence/reverseNumberSequence.jsx";
import RememberTheNumber from "../../../container/tRememberTheNumber/rememberTheNumber.jsx";
import PatternPairAssociation from "../../../container/tPatternPairAssociation/patternPairAssociation.jsx";

function StartedAmazeTest() {
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  let { launchTestData, loader, err } = launchTestC;

  const { helperC, dispatchHelper } = HelperContext();
  const { answerC } = AnswerContext();

  const { runningQuesId } = helperC;

  const [isShuffeled, setIsShuffeled] = useState(false);

  const shuffle = (arr) => {
    const newArr = [...arr];

    let curIndex = arr.length;
    let tempValue, randomIndex;

    while (curIndex !== 0) {
      randomIndex = Math.floor(Math.random() * curIndex);
      curIndex -= 1;

      tempValue = newArr[curIndex];
      newArr[curIndex] = newArr[randomIndex];
      newArr[randomIndex] = tempValue;
    }

    // swap que with id 1 to front for the runningQuesId check in getTest.jsx
    const queIdOneIndex = newArr.findIndex((que) => que.id.toString() === "1");
    tempValue = newArr[0];
    newArr[0] = newArr[queIdOneIndex];
    newArr[queIdOneIndex] = tempValue;

    return newArr;
  };

  let launchTestQue =
    objectValidation(launchTestData) && launchTestData.data[0].que;

  if (objectValidation(launchTestData)) {
    if (launchTestData.data[0].test_format === "tap_letter") {
      launchTestQue = [...getCPTData(helperC.testType)];
      if (!isShuffeled) {
        launchTestData.data[0].que = shuffle(launchTestQue);
        setIsShuffeled(true);
      }
      // launchTestData.data[0].que = launchTestQue;
      // launchTestData.data[0].que = shuffle(launchTestQue);
    } else if (launchTestData.data[0].test_format === "visual_facename_mix") {
      launchTestQue = {
        ...getVisualFNMix(helperC.faceData, dispatchHelper, helperC.testType),
      };
      launchTestData.data[0].que = launchTestQue;
    } else if (launchTestData.data[0].test_format === "listen_speak_series") {
      launchTestQue = [
        ...getSpeedImgRecall(launchTestData.data[0].que, helperC.testType),
      ];
      launchTestData.data[0].que = launchTestQue;
    } else if (launchTestData.data[0].info_audio === "text_matching") {
      launchTestQue = [
        ...getTextMatching(launchTestData.data[0].que, helperC.testType),
      ];
      launchTestData.data[0].que = launchTestQue;
      console.log("textquestion questions", launchTestData.data[0]);
    }
  }

  // resetting total tap on launch test for cpt and shuffeledImage (que_ids) for speed image recall
  useEffect(() => {
    objectValidation(launchTestData) &&
      launchTestData.data[0].test_format === "tap_letter" &&
      dispatchHelper({ type: "RESET_TOTAL_TAP" });

    // objectValidation(launchTestData) &&
    //   launchTestData.data[0].test_format === "listen_speak_series" &&
    //   dispatchHelper({
    //     type: "SET_SHUFFELED_IMAGE",
    //     payload: launchTestQue[0].questionArray.reduce(
    //       (str, ques, i) => `${str}${i !== 0 ? "," : ""}${ques.id}`,
    //       ""
    //     ),
    //   });
  }, []);

  return (
    <>
      {/* // this loader applies only on non-audio test, loader for audio is inbuilt inside audio test component */}
      {answerC.isLoading && !helperC.isAudioTest && <FullScreenLoader />}
      {answerC.isLoading && // special case for sound differentiation, it is audio test but template is multiTap
        launchTestData.data[0].test_format === "listen_sound_differ" && (
          <FullScreenLoader />
        )}
      <>
        {runningQuesId !== "submitted" ? (
          // false
          <>
            {/* --------------------non audio test-------------------- */}
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="visual_keypad"
              Component={VisualKeypad}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="multi_tap"
              Component={MultiTap}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="single_tap_two"
              Component={MultiTap}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="single_tap"
              Component={MultiTap}
            ></GetTest>
            {helperC.testType === "DEMO" ? (
              <GetTest
                actualTestFormat={launchTestData.data[0].test_format}
                // actualTestFormat={launchTestData.data[0].section_id}
                questions={launchTestData.data[0].que}
                testFormat="text_match_scroll"
                Component={MultiTap}
              ></GetTest>
            ) : (
              <GetTest
                actualTestFormat={launchTestData.data[0].test_format}
                // actualTestFormat={launchTestData.data[0].section_id}
                questions={launchTestData.data[0].que}
                testFormat="text_match_scroll"
                Component={TextMatch}
              ></GetTest>
            )}

            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="multi_fill"
              Component={MultiFill}
            ></GetTest>
            <GetTest
              questions={launchTestData.data[0].test_format}
              actualTestFormat={launchTestData.data[0].que}
              testFormat="letter_typing"
              Component={MultiFill}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="visual_facename_mix"
              Component={FaceNameMix}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="visual_shuffle"
              Component={ShuffleSentence}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="digit_span"
              Component={DigitMemorySpan}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="digit_reverse_span"
              Component={DigitMemorySpan}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="reverse_number_sequence"
              Component={ReverseNumberSequence}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="remember_the_numbers"
              Component={RememberTheNumber}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="pattern_pair_association"
              Component={PatternPairAssociation}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat=""
            ></GetTest>

            {/* --------------------reaction test-------------------- */}
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="simple_reaction"
              Component={SimpleReaction}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="choice_reaction"
              Component={ChoiceReaction}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              // for shuffeling part
              // questions={shuffle([...launchTestData.data[0].que])}
              testFormat="tap_letter"
              Component={CPT}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="tap_nback1"
              Component={DualNBack1}
            ></GetTest>

            {/* --------------------audio test-------------------- */}
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="listen_speak"
              Component={ListenSpeak}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="listen_speak_soundlist"
              Component={ListenSpeak}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="listen_speak_sound"
              Component={ListenSpeak}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              // this component is same as ListenSpeak
              testFormat="listen_speak_para"
              Component={ListenSpeakPara}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="listen_sound_differ"
              Component={MultiTap}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="listen_speak_series"
              Component={SpeedImgRecall}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="simple_reaction_sound"
              Component={SimpleSoundReaction}
            ></GetTest>
            <GetTest
              actualTestFormat={launchTestData.data[0].test_format}
              questions={launchTestData.data[0].que}
              testFormat="listen_speak_fluency"
              Component={ListenSpeak}
            ></GetTest>
          </>
        ) : (
          <TestSummary
            questions={
              //special condition for the separation of face name test to other test (face name test is custom generated test on frontend)
              launchTestData.data[0].test_format === "visual_facename_mix"
                ? launchTestData.data[0].que.faceArray
                : launchTestData.data[0].que
            }
          />
        )}
      </>
    </>
  );
}

export default React.memo(StartedAmazeTest);
